import React from "react";
import { Input, Box } from "@chakra-ui/react";

const TextBox = ({ name, placeholder, value, onChange }) => {
  return (
    <div style={{ marginBottom: "50px" }}>
      <Box
        bg="#E2E2E2"
        p={3}
        borderRadius="md"
        position="relative"
        width="100%"
      >
        <Input
          name={name} // Ensure name is passed
          value={value} // Ensure value is controlled
          onChange={onChange} // Pass onChange to update state
          variant="unstyled"
          placeholder={placeholder}
          fontStyle="italic"
          _focus={{ outline: "none" }}
        />
        <Box
          height="4px"
          bg="#00CEA0"
          width="100%"
          position="absolute"
          bottom="0"
          left="0"
        />
      </Box>
    </div>
  );
};

export default TextBox;
